<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VGraq3/images/cover.jpg?1702489399923" alt="This image is the cover for the book Trench Warfare, The Illustrated War Reports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trench Warfare, The Illustrated War Reports
      </h1>
      <p class="bookDescription body article font2">
        <p>This powerful collection, depicting the grim events of trench warfare, showcases the work of the contemporary combat artists and illustrators from the Great War era. Included here are the works of serious artists, propagandists, illustrators and humorists. The result is a stunning and vivid graphic record of life and death in the trenches during the Great War, as reported to contemporary audiences at a time when the events of the Great War were still unfolding. During the Great War artists and illustrators produced a highly accurate visual record of the fleeting moments the bulky cameras couldnt reproduce. These works form a body ofwar reportage that are as valid as the written word. Today, the work of the combat illustrators and the official war artists from the Great War era is overlooked by historians in favor of photographs, but these illustrations are nonetheless important, as they provide a contemporary record of hand-to-hand fighting, trench raids, aerial dogfights, sea battles, desperate last stands, night actions and cavalry charges.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Carruthers
      </h2>
      
      <p class="authorDescription body article">Bob Carruthers is an Emmy Award winning author and historian, who has written extensively on the Great War. A graduate of Edinburgh University, Bob is the author of a number of military history titles including the Amazon best seller The Wehrmacht in Russia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07fd428e